export const DEFAULT = 'Default';
export const GOOGLE_APPS_ONLY = 'GoogleAppsOnly';
export const SAML = 'SAML';

export const LOGIN_AUTH_POLICY_OPTIONS = [
  { label: 'Default (email address and password)', value: DEFAULT, dataTest: DEFAULT },
  { label: 'Require Google Sign-In', value: GOOGLE_APPS_ONLY, dataTest: GOOGLE_APPS_ONLY },
  { label: 'SAML', value: SAML, dataTest: SAML },
];

/**
 * These Authentication policy constants map to the values returned as keys
 * from the org auth methods endpoint: '/i/orgs/current/authMethods'
 */
export const USERNAME_PASSWORD = 'userPassAuthEnabled';
export const GOOGLE_SIGNIN = 'googleAuthEnabled';
export const SSO = 'samlAuthEnabled';
export const SAML_DOMAIN = 'samlDomain';
export const SAML_METADATA = 'samlMetadata';

export const AUTH_METHOD_LABELS = {
  [USERNAME_PASSWORD]: 'Username and password',
  [GOOGLE_SIGNIN]: 'Google Sign-In',
  [SSO]: 'Single Sign-on (SSO) via SAML',
};

export const SAML_LABELS = {
  [SAML_DOMAIN]: 'SAML domain',
  [SAML_METADATA]: 'SAML metadata',
};
